var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 12.5924H4.27614L10.4853 6.38321L9.54247 5.44041L3.33333 11.6496V12.5924ZM14 13.9257H2V11.0972L10.9567 2.14057C11.2171 1.88023 11.6391 1.88023 11.8995 2.14057L13.7851 4.02619C14.0455 4.28654 14.0455 4.70865 13.7851 4.969L6.16176 12.5924H14V13.9257ZM10.4853 4.4976L11.4281 5.44041L12.3709 4.4976L11.4281 3.55479L10.4853 4.4976Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.b2b1f272f9052877ecc08a79062b4cdc.svg";
export { ForwardRef as ReactComponent };